module.exports = __webpack_public_path__ + "img/entity1.afe89c48.png";